module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.queryParam.type == 0 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickTypeButton(0)
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.queryParam.type == 1 ? 'primary' : 'plain'
    },
    on: {
      "click": function($event) {
        return _vm.clickTypeButton(1)
      }
    }
  }, [_vm._v("\n         " + _vm._s('未关联学校' + (_vm.queryParam.type == 1 && _vm.unassociatedCount ? _vm.unassociatedCount : '')) + "\n      ")]), _vm._v(" "), _c('el-form', {
    staticClass: "margin-left-20",
    attrs: {
      "inline": "",
      "model": _vm.queryParam
    }
  }, [(_vm.queryParam.type != 1) ? _c('el-form-item', {
    attrs: {
      "label": "校区名称"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择校区",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "schoolId", $$v)
      },
      expression: "queryParam.schoolId"
    }
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备UID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入设备UID",
      "clearable": "",
      "maxlength": 100
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息同步进度"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.queryParam.synSchedule),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "synSchedule", $$v)
      },
      expression: "queryParam.synSchedule"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "处理中",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已完成",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickQuery
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "80",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "设备ID",
      "prop": "onePcId"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "关联学校",
      "prop": "schoolName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "激活时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.row.activeTime ? _vm.$util.dateFormat(new Date(_vm.row.activeTime)) : ''))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学生信息同步进度"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_vm._v(_vm._s(_vm.handleSynSchedule(_vm.row)))])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "280"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(!_vm.row.schoolId || _vm.row.schoolId === '') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.clickBinding(_vm.row)
              }
            }
          }, [_vm._v("\n                  绑定学校\n               ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.clickDelete(_vm.row)
              }
            }
          }, [_vm._v("删除设备")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total > 0"
    }],
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    ref: "bindingDialogRef",
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": "绑定学校",
      "close-on-click-modal": false,
      "modal-append-to-body": true,
      "modal": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.bindingDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickBindingDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.bindingDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.bindingDialog, "visible", $$v)
      },
      expression: "bindingDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择学校"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择学校",
      "filterable": ""
    },
    model: {
      value: (_vm.bindingDialog.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.bindingDialog, "schoolId", $$v)
      },
      expression: "bindingDialog.schoolId"
    }
  }, _vm._l((_vm.bindingDialog.schoolOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-682d2299!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/EquipmentList/EquipmentPhysical/EquipmentPhysical.vue
// module id = 1058
// module chunks = 0